export default {
    list: {
        title: "Activity",
        subtitle: "Visualizza attività recente",
        loading: "Caricamento attività...",
    },
    sender: {
        title: "Activity",
        subtitle: "Aggiornamenti e notifiche per il tuo account Sender",
    },
    shipper: {
        title: "Activity",
        subtitle: "Aggiornamenti e notifiche per il tuo account Shipper",
    },
    receiver: {
        title: "Activity",
        subtitle: "Aggiornamenti e notifiche per il tuo account Receiver",
    },
    freightForwarder: {
        title: "Activity",
        subtitle: "Aggiornamenti operativi per il tuo account Freight Forwarder",
    },
    actions: {
        markAllAsRead: "Segna tutto come letto",
        markingAsRead: "Marcando...",
    },
    tradeComms: {
        title: "Trade Communications",
        goToEmailSettings: "Vai alle impostazioni email",
        sidebarTitle: "Trade Communications",
        collapseSidebar: "Comprimi barra laterale",
        expandSidebar: "Espandi barra laterale",
        allInbox: "Tutte le email in inbox",
        allLimbo: "Tutte le email che richiedono revisione",
        accounts: "Account",
        accountAll: "Tutte le email dell'account",
        reviewNeeded: "Revisione richiesta",
        selectEmail: "Seleziona un'email per visualizzare il contenuto",
        noInbox: "Nessuna email in inbox",
        noLimbo: "Nessuna email in limbo",
        searchEmails: "Cerca email...",
        yesterday: "Ieri",
    },
    systemLogs: {
        title: "System Activity Logs",
    },
    activityItem: {
        actionNeeded: "Azione richiesta",
        reviewed: "Rivisto",
        requiresReview: "Richiede revisione",
        account: "Account:",
        from: "Da:",
        received: "Ricevuta:",
        subject: "Oggetto:",
        hideRecap: "Nascondi recap",
        showRecap: "Mostra recap",
        file: "File:",
        type: "Tipo:",
        category: "Categoria:",
        uploadedBy: "Uploadato da:",
        classifiedBy: "Classificato da:",
        source: "Fonte:",
        sourceEmail: "Da email",
        sourceManual: "Upload manuale",
        reportedBy: "Segnalato da:",
        severity: "Severità:",
        name: "Nome:",
        email: "Email:",
        company: "Azienda:",
        role: "Ruolo:",
        modifiedBy: "Modificato da:",
        modifiedFields: "Campi modificati:",
        delayHours: "{{hours}}h di ritardo",
        originalEta: "ETA originale:",
        currentEta: "ETA corrente:",
        vessel: "Nave:",
        passed: "{{count}} superati",
        failed: "{{count}} falliti",
        missing: "{{count}} mancanti",
        skipped: "{{count}} ignorati",
        hideDetails: "Nascondi dettagli",
        issuesDetected: "{{count}} problemi rilevati",
        moreOthers: "+ {{count}} altri",
        risk: "Rischio:",
        activeIssues: "Issue attive:",
        issuesAutoClosed: "{{count}} issue auto-chiuse",
        container: "Container:",
        moreAttachments: "+ {{count}} allegati",
        containerDeleted: "Container eliminato",
        containerDeletedTooltip: "Il container è stato eliminato",
        synced: "Sincronizzato",
        fields: {
            actualDepartureDate: "Data partenza effettiva",
            riskScore: "Livello di rischio",
            destinationPortId: "Porto di destinazione",
            totalValueUsd: "Valore (USD)",
            physicalStatus: "Stato fisico",
            status: "Stato",
            containerNumber: "Numero container",
            bookingNumber: "Numero booking",
            estimatedArrivalDate: "ETA",
            estimatedDepartureDate: "ETD",
        },
    },
    emailActions: {
        markNotInContext: {
            label: "Non in Contesto",
            confirmTitle: "Rimuovi Email dal Contesto",
            confirmMessage:
                "Sei sicuro di voler marcare questa email come non rilevante? L'email verrà rimossa dal contesto logistico e non verrà più processata.",
            cancel: "Annulla",
            confirm: "Rimuovi dal Contesto",
            marking: "Rimozione...",
            success: "Email marcata come non in contesto",
            error: "Errore nel marcare l'email",
        },
        closeDetail: "Chiudi dettaglio",
        associateContainer: {
            label: "Associa a Container",
            title: "Associa Email a Container",
            description: "Seleziona il container a cui vuoi associare questa email. Il sistema processerà automaticamente il contenuto.",
            inputLabel: "Container Number",
            inputPlaceholder: "Cerca e seleziona un container...",
            loadingContainers: "Caricamento container...",
            cancel: "Annulla",
            confirm: "Associa",
            associating: "Associando...",
            success: "Email associata al container con successo",
            error: "Errore nell'associazione dell'email",
        },
    },
    activityFeed: {
        categories: {
            document: "Documenti",
            tracking: "Tracking",
            issue: "Issue",
            email: "Email",
            contact: "Rubrica",
            agent: "Sistema",
            other: "Altro",
        },
        sectionSettings: "Impostazioni sezioni",
        sectionOrderVisibility: "Ordine e visibilità sezioni",
        loadMoreActivities: "Carica altre attività",
        nextSlide: "Slide successiva",
        noActivities: "Nessuna attività trovata con i filtri selezionati.",
        noMoreToLoad: "Nessun altro caricamento",
        expandSection: "Espandi {{label}}",
        collapseSection: "Comprimi {{label}}",
        moveUp: "Sposta {{label}} su",
        moveDown: "Sposta {{label}} giù",
        show: "Mostra",
        hide: "Nascondi",
    },
};
